module.exports = __webpack_public_path__ + "catalog/items/heating_Electrical/Square-Boiler-with-B/Square-Boiler-with-B.svg";